<template>
  <div class="user-login">
        <div class="lang-con">
            <div class="lang-select" @click="handlerSelectLang">
                <span class="lang-val">{{ selectLangType.text }}</span>
                <i class="fas fa-chevron-down"></i>
            </div>
        </div>
        <van-form @submit="submit" ref="Form">
            <van-field
                @touchstart="handleForceFocus('userLoginInput')"
                @click="handleForceFocus('userLoginInput')"
                ref="userLoginInput"
                class="user-login-input"
                v-model.trim="value"
                clearable
                :placeholder="$t('view_country_input')"
                :error="inputError"
            />
            <div>
                <van-button class="login-btn" :disabled="btnIsDisabled" round block type="info" native-type="submit">{{ $t('feedback.submit') }}</van-button>
            </div>
        </van-form>
  </div>
</template>

<script>
import {  Button, Form } from "vant";
import md5 from 'js-md5';
import Projectconfig from '@/data/projectconfig.js'
export default {
    name: "UserLogin",
    props: {
        selectLangType: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },
    components: {
        vanButton: Button,
        vanForm: Form,
    },
    data() {
        return {
            value: '',
            projectConfigObj: {},
            inputError: false,
        }
    },
    computed: {
        btnIsDisabled() {
            return this.value.trim().length === 0;
        }
    },
    mounted() {
        this.getProjectConfig();
    },
    methods: {
        // 获取projectConfig
        getProjectConfig(){
            let enterpriseMap = {
                '/pl': 'EA00011095',
                '/ottocast': 'EA00011068'
            }
            let path = this.$route.path;
            let enterprisecode = this.$route.query.enterprisecode || enterpriseMap[path];
            Projectconfig.getConfig(enterprisecode + '.json').then(d => {
                this.projectConfigObj = d || {};
            })
        },
        // 输入框获取焦点
        handleForceFocus(ref) {
            setTimeout(() => {
                this.$refs[ref]?.focus();
                this.inputError = false;
            }, 200);
        },
        submit() {
            if(this.value.trim().length === 0) return;
            try {
                let encryptedValue = md5(this.value.trim());
                let users = this.projectConfigObj.Public_Package_Users || [];
                if(users.includes(encryptedValue)){
                    this.$emit('update:isShowUserLogin', false);
                    let userLoginInfo = {
                        login_time: Date.now(),
                        userAccount: encryptedValue,
                        user_account: this.value.trim(),
                    };
                    // 神策-设置公共属性
                    this.$sensors.registerPage({
                        user_account: this.value.trim(),
                    });
                    sessionStorage.setItem('package_user',JSON.stringify(userLoginInfo));
                    this.inputError = false;
                    this.value = '';

                    setTimeout(() => {
                        window.location.reload();
                    }, 100);
                } else {
                    this.inputError = true;
                }
            } catch (error) {
                console.error('UserLogin submit error:', error);
            }
        },
        handlerSelectLang() {
            this.$emit('selectLang');
        },
    }
}
</script>

<style lang="less" scoped>
.user-login {
    background-color: #fff;
    padding: 12px;
    min-height: 100vh;
    .lang-con {
        display: flex;
        justify-content: flex-end;
    }
    .lang-select {
        min-width: 104px;
        padding: 0 13px;
        line-height: 32px;
        height: 32px;
        border-radius: 16px;
        font-size: 14px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: space-between;
        align-items: center;
        // background-color: color-mix(in oklab, #fff 20%, transparent);
        background-color: #fff;
        margin-bottom: 10px;
        .lang-val {
            flex: 1;
            margin-right: 5px;
        }
        .down {
            width: 10px;
            height: 8px;
        }
    }
    .user-login-input {
        margin-top: 100px;
        background-color: #fff;
        border: 1px solid #d1d5dc;
        border-radius: 8px;
        margin-bottom: 22px;
        &:focus-within {
            background: rgba(67, 97, 238, 0.05);
            border: 1px solid #4361ee;
        }
    }
    .login-btn {
        background-color: #4361ee;
        border-radius: 6px;
        border:#4361ee;
        margin-top: 22px;
    }
}
html[dir='rtl'] .user-login {
    .lang-con {
        .lang-select {
            .lang-val {
                margin-right: unset;
                margin-left: 5px;
            }
        }
    }
    ::v-deep {
        .van-field__control,.van-field__error-message {
            text-align: right;
        }
    }
}
</style>